import { cn } from "../../lib/format";
import { useT } from "../../i18n";

interface StepProgressProps {
  steps: string[];
  /** Zero-based index of the current step. */
  current: number;
}

/** One bar per step: blue up to the current one, grey after. */
export default function StepProgress({ steps, current }: StepProgressProps) {
  const t = useT();
  return (
    <ol
      aria-label={t.auth.companySignup.stepOf(current + 1, steps.length)}
      className="m-0 mb-6 grid list-none gap-2 p-0"
      style={{ gridTemplateColumns: `repeat(${steps.length}, 1fr)` }}
    >
      {steps.map((label, i) => (
        <li
          key={label}
          aria-current={i === current ? "step" : undefined}
          className={cn(
            "border-t-[3px] pt-2 text-[13px]",
            i <= current ? "border-brand" : "border-line-strong",
            i === current ? "text-ink" : "text-faint",
          )}
        >
          {label}
        </li>
      ))}
    </ol>
  );
}
